import { useEffect, useMemo, useRef } from "react";

export const Starfield = () => {
  const ref = useRef(null);
  const stars = useMemo(
    () =>
      Array.from({ length: 130 }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 1.8 + 0.6,
        delay: Math.random() * 7,
        dur: 2.6 + Math.random() * 4.5,
        opacity: 0.25 + Math.random() * 0.6,
      })),
    []
  );

  /* a ogni movimento le stelle si accendono, con una lenta parallasse */
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let glowTimer = null;
    let raf = null;
    const onScroll = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        el.style.transform = `translateY(${window.scrollY * 0.05}px)`;
      });
      el.classList.add("starfield--alive");
      clearTimeout(glowTimer);
      glowTimer = setTimeout(() => el.classList.remove("starfield--alive"), 650);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      clearTimeout(glowTimer);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="starfield" ref={ref} aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="star"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            opacity: s.opacity,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
          }}
        />
      ))}
      <span className="shooting-star shooting-star--1" />
      <span className="shooting-star shooting-star--2" />
    </div>
  );
};
